import React from 'react';
import ASteps from 'antd-mobile/lib/steps';



export default class Steps extends ASteps {}